import * as React from 'react';
import sanitizeHtml from 'sanitize-html';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';

import SOVModalMeta from 'modules/insights/sov/components/modals/meta/SOVModalMeta';

import { __t, applyTranslations } from 'utils/language';
import { FIXED_TO_TOP } from 'modules/insights/sov/utils/sov';

import './sov-teaser-freemium.scss';

import type { SOVGeneralProps } from 'modules/insights/sov/types';

applyTranslations(require('./sov-teaser-freemium.i18n.json'));

type Props = {
  reportProps: SOVGeneralProps,
  hasReports: boolean
};

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['strong']
};

const ActionButtonWithModal = withModal(ActionButton, {
  modalContent: SOVModalMeta,
  width: 'small',
  positionOverride: FIXED_TO_TOP
});

const MSG_KEY = 'sov_teaser_freemium';

class SOVTeaserFreemium extends React.PureComponent<Props> {
  renderHeader(): React.ReactNode {
    return (
      <div
        className="sov-teaser-freemium__header"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(__t(`${MSG_KEY}.header`), SANITIZE_HTML_CONFIG)
        }}
      />
    );
  }

  renderFooter(): React.ReactNode {
    const { reportProps, hasReports } = this.props;
    const buttonText = __t(`${MSG_KEY}.buttons.create_${hasReports ? 'new' : 'first'}`);

    return (
      <div className="sov-teaser-freemium__footer">
        <ActionButtonWithModal
          modalContentProps={reportProps}
          color="primary"
        >
          {buttonText}
        </ActionButtonWithModal>
      </div>
    );
  }

  renderBody(): React.ReactNode {
    const items = [
      { key: 'competitor', image: 'graph', style: { width: 405 } },
      { key: 'posting', image: 'top-creator', style: { width: 203 } },
      { key: 'saying', image: 'mentions', style: { width: 155 } }
    ];

    return (
      <div className="sov-teaser-freemium__body">
        {
          items.map(item => (
            <React.Fragment key={`sov-teaser-freemium--item-${item.key}`}>
              <div className="sov-teaser-freemium__body-message">
                {__t(`${MSG_KEY}.messages.${item.key}`)}
              </div>
              <div
                className="sov-teaser-freemium__body-image"
                style={item.style}
              >
                <img
                  data-src={`/static/images/sov-teaser-freemium-${item.image}.png`}
                  className="lazyload"
                  alt={item.image}
                />
              </div>
            </React.Fragment>
          ))
        }
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="sov-teaser-freemium">
        {this.renderHeader()}
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    );
  }
}

export default SOVTeaserFreemium;
